import {CheckoutRedemption, Deal, Product, Stock} from "@irati/types"

interface Voucher extends Stock {
  deal: Deal
  product: Product
}

/**
 * @note This whole file is disgusting, should not be merging objects together to create something like this.
 */
export const getVouchersFromRedemption = (redemption: CheckoutRedemption, deal?: Deal) => {
  const codes: Voucher[] = []
  redemption.order.products.forEach((p) => {
    p.items.forEach((item) => {
      const voucher: Voucher = {
        ...item,
        product: p.product,
        deal: deal || redemption.dealSnapshot
      }
      codes.push(voucher)
    })
  })

  return codes
}
